import { render, staticRenderFns } from "./OnSuppPdpGuidance.vue?vue&type=template&id=2f690be2&lang=pug"
import script from "./OnSuppPdpGuidance.vue?vue&type=script&lang=js"
export * from "./OnSuppPdpGuidance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports